import type {InjectionKey} from 'vue';

/**
 * What the auth card pins over its own scrollport, resolved by the template that owns it.
 *
 * A form inside the card has to know what covers the band the reader can see before it scrolls a
 * field into it. The pinned pieces belong to the template, not to the form, and finding them by
 * class name from the other side is a contract nothing enforces — so the template hands them over.
 */
export interface AuthCardOverlays {
  /** The banner pinned over the top of the card, or null when there is none or it is not pinned. */
  banner(): HTMLElement | null;
}

export const authCardOverlaysKey: InjectionKey<AuthCardOverlays> = Symbol('authCardOverlays');
